declare const window: any;

window.dataLayer = window.dataLayer || [];

export function tracker(...args: any[]) {
  window.dataLayer.push(arguments);
}
